import { Params } from '../../core/adaptor';
import { interaction, animation, theme, annotation, slider } from '../../adaptor/common';
import { schema } from '../../adaptor/geometries';
import { flow, pick, deepAssign } from '../../utils';
import { AXIS_META_CONFIG_KEYS } from '../../constant';

import { Y_FIELD, TREND_FIELD, TREND_UP, TREND_DOWN } from './constant';
import { StockOptions } from './types';
import { getStockData } from './utils';

/**
 * å¾è¡¨éç½®å¤ç
 * @param params
 */
function geometry(params: Params<StockOptions>): Params<StockOptions> {
  const { chart, options } = params;
  const { yField } = options;

  const { data, risingFill, fallingFill, tooltip, stockStyle } = options;

  chart.data(getStockData(data, yField));

  let tooltipOptions = tooltip;
  if (tooltipOptions !== false) {
    tooltipOptions = deepAssign({}, { fields: yField }, tooltipOptions);
  }

  schema(
    deepAssign({}, params, {
      options: {
        schema: {
          shape: 'candle',
          color: [risingFill, fallingFill],
          style: stockStyle,
        },
        yField: Y_FIELD,
        seriesField: TREND_FIELD,
        rawFields: yField,
        tooltip: tooltipOptions,
      },
    })
  );

  return params;
}

/**
 * meta éç½®
 * @param params
 */
export function meta(params: Params<StockOptions>): Params<StockOptions> {
  const { chart, options } = params;
  const { meta, xAxis, yAxis, xField } = options;

  const baseMeta = {
    [xField]: {
      type: 'timeCat',
      tickCount: 6,
    },
    [TREND_FIELD]: {
      values: [TREND_UP, TREND_DOWN],
    },
  };

  const scales = deepAssign(baseMeta, meta, {
    [xField]: pick(xAxis, AXIS_META_CONFIG_KEYS),
    [Y_FIELD]: pick(yAxis, AXIS_META_CONFIG_KEYS),
  });

  chart.scale(scales);

  return params;
}

/**
 * axis éç½®
 * @param params
 */
export function axis(params: Params<StockOptions>): Params<StockOptions> {
  const { chart, options } = params;
  const { xAxis, yAxis, xField } = options;

  // ä¸º false åæ¯ä¸æ¾ç¤ºè½´
  if (xAxis === false) {
    chart.axis(xField, false);
  } else {
    chart.axis(xField, xAxis);
  }

  if (yAxis === false) {
    chart.axis(Y_FIELD, false);
  } else {
    chart.axis(Y_FIELD, yAxis);
  }

  return params;
}

/**
 * tooltip éç½®
 * @param params
 */
export function tooltip(params: Params<StockOptions>): Params<StockOptions> {
  const { chart, options } = params;
  const { tooltip } = options;

  if (tooltip !== false) {
    chart.tooltip(tooltip);
  } else {
    chart.tooltip(false);
  }

  return params;
}

/**
 * legend éç½®
 * @param params
 */
export function legend(params: Params<StockOptions>): Params<StockOptions> {
  const { chart, options } = params;
  const { legend } = options;

  if (legend) {
    chart.legend(TREND_FIELD, legend);
  } else if (legend === false) {
    chart.legend(false);
  }

  return params;
}

/**
 * Kçº¿å¾ééå¨
 * @param chart
 * @param options
 */
export function adaptor(params: Params<StockOptions>) {
  // flow çæ¹å¼å¤çææçéç½®å° G2 API
  flow(theme, geometry, meta, axis, tooltip, legend, interaction, animation, annotation(), slider)(params);
}
